<template>
    <div :class="className" @click="signatrueHandler">
        <div v-if="!imgSrc">
            서명란을 클릭해주세요.
        </div>
        <img v-else :src="imgSrc" alt="signature" />
    </div>
</template>
<script>
export default {
    name: "SignatureBox",
    props: [
        "no",
        "parentNo",
        "mode",
        "type",
        "status",
        "value",
        "isInput",
        "onChange",
        "onSignature"
    ],
    computed: {
        imgSrc() {
            return this.value[0];
        },

        className() {
            const classNames = ["signature-boards", this.status];
            return classNames.join(" ");
        }
    },
    methods: {
        signatrueHandler() {
            if (this.status === "update" && this.imgSrc) {
                this.$alert.danger({
                    message: "서명을 제출한 상태이므로 변경이 어렵습니다."
                });
                return;
            }

            this.onSignature({
                parentNo: this.parentNo,
                no: this.no,
                mode: this.mode
            });
        }
    }
};
</script>
<style lang="scss">
.signature-boards {
    position: relative;
    border: 1px solid #ccc;
    color: #ccc;
    height: 150px;
    width: 300px;
    margin: 0 auto;

    display: flex;
    align-items: center;
    justify-content: center;

    img {
        border: 1px solid #ccc;
    }

    &.update {
        // &:after {
        //     content: "";
        //     position: absolute;
        //     top: 0;
        //     bottom: 0;
        //     right: 0;
        //     left: 0;
        //     background-color: rgba(255, 255, 255, 0.8);
        //     z-index: 99;
        // }
    }
}
</style>
